import WidgetContainer from "../../../widget-container";
import { useCategories } from "../../categories.hook";
import styles from "./categories-skin-1.module.css";
import { WidgetType } from "@commons-monorepo/index";

type Props = {
  type: WidgetType;
};

const CategoriesSkin1 = ({ type }: Props) => {
  const { categories } = useCategories();

  return (
    <WidgetContainer
      className={styles.widgetContainer}
      containerClassName={styles.widgetContainerContent}
      withoutPaddingY>

      <div className={`${styles.categoriesSkin1Container}`}>
        {categories?.map((category: any, index: number) =>
        <div
          key={`category-key-${index}`}
          className={`${styles.categoryItem} ${
          type === WidgetType.CATEGORIES_SKIN_2 ?
          styles.categoryItemButton :
          ""
          }`}
          onClick={category.onClick}>

            {category.name}
          </div>
        )}
      </div>
    </WidgetContainer>);

};

export default CategoriesSkin1;